<template>
  <div class="breadcrumb-main">
    <div class="page-width">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('home') }}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="path1" :to="path1.path">{{path1.name}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{path2}} </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "breadcrumb",
  props: ['path1', 'path2']
}
</script>

<style scoped lang="less">
@import "../assets/css/navbar.less";
@import "../assets/css/public.less";
  .breadcrumb{
    padding: 20px 0;
    .el-breadcrumb{
      .el-breadcrumb__item{
        margin-bottom: 5px;
        /deep/.el-breadcrumb__inner{
          font-size: 16px;
          color: #333;
        }
        /deep/.is-link{
          font-size: 16px;
          color: #B5B5B5;
        }
      }
    }
  }
  @media only screen and (max-width: 1299px) {
    .breadcrumb{
      // padding: 0;
    }
  }
  @media only screen and (max-width: 767px) {
    .breadcrumb-main{
      .page-width{
        padding: 0 !important;
      }
    }
  }
  @media only screen and (max-width: 479px) {
    .breadcrumb{
      .el-breadcrumb{
        .el-breadcrumb__item{
          /deep/.el-breadcrumb__inner{
            font-size: 12px;
            color: #333;
          }
          /deep/.is-link{
            font-size: 12px;
            color: #B5B5B5;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue